import React, { useState, useEffect } from 'react';
import { TicketProfile } from './TicketProfile';
import { BillProfile } from './BillProfile';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { RadioInput } from '@app/src/common/RadioInput';
import {
  Label,
  ActionProfile,
  Wrapper
} from './styled';

interface Props {
  handleChangeAction?: Function;
  getProfileType?: Function;
  color?: string;
}

export const TabProfile: React.FC<Props> = ({ handleChangeAction, getProfileType, color }) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState('DNI');

  useEffect(() => {
    getProfileType && getProfileType(active);
  }, [active])

  const handleChange = (value: string) => {
    handleChangeAction('stepPayment', 'dni');
    handleChangeAction('stepPayment', 'name');
    handleChangeAction('stepPayment', 'fatherLastName');
    handleChangeAction('stepPayment', 'motherLastName');
    handleChangeAction('stepPayment', 'phone');
    handleChangeAction('stepPayment', 'email');
    handleChangeAction('stepPayment', 'ruc');
    handleChangeAction('stepPayment', 'rznSocial');
    handleChangeAction('stepPayment', 'businessName');
    handleChangeAction('stepPayment', 'businessFatherLastName');
    handleChangeAction('stepPayment', 'businessMotherLastName');
    handleChangeAction('stepPayment', 'businessAddress');
    handleChangeAction('stepPayment', 'businessPhone');
    handleChangeAction('stepPayment', 'location');
    handleChangeAction('stepPayment', 'businessEmail');
    handleChangeAction('stepPayment', 'termsAndConditions');
    dispatch(change('stepPayment', 'documentType', value));
    dispatch(change('stepPayment', 'termsAndConditions', false));
    setActive(value)
  }

  return(
  <Wrapper>
    <Label>Seleccionar tipo de comprobante</Label>
    <ActionProfile>
      <RadioInput
        name="documentType"
        colorActive={color}
        value="DNI"
        checked={active === 'DNI'}
        text="Boleta"
        handleChange={handleChange}
      />
      <RadioInput
        name="documentType"
        colorActive={color}
        value="RUC"
        checked={active == 'RUC'}
        text="Factura"
        handleChange={handleChange}
      />
    </ActionProfile>
    { active === 'DNI' ? <TicketProfile color={color} /> : <BillProfile color={color} /> }
  </Wrapper>
)};
